export default __webpack_public_path__ + "static/scc-c7e2f67122d717449e79a20716bf4ac1.png";